import { PureComponent } from 'react';
import { withSnackbar } from 'notistack';
import { has } from './../../config/constants';

class Alert extends PureComponent {
    displayed = {
        success : [],
        error   : [],
        info    : [],
        warning : []
    };

    componentDidUpdate() {
        const { 
            success, info, error, warning,
            enqueueSnackbar, removeSuccess,
            removeError, removeWarning,
            removeInfo
        } = this.props;

        for( let key in success ) {
            if( has.call( success, key ) && this.displayed.success.indexOf( key ) === -1 ) {
                enqueueSnackbar( success[ key ], {
                    preventDuplicate : true,
                    variant          : 'success'
                });

                this.displayed.success = [
                    ...this.displayed.success,
                    key
                ];

                removeSuccess( key );
            }
        }

        for( let key in info ) {
            if( has.call( info, key ) && this.displayed.info.indexOf( key ) === -1 ) {
                enqueueSnackbar( info[ key ], {
                    preventDuplicate : true,
                    variant          : 'info'
                });

                this.displayed.info = [
                    ...this.displayed.info,
                    key
                ];

                removeInfo( key );
            }
        }

        for( let key in error ) {
            if( has.call( error, key ) && this.displayed.error.indexOf( key ) === -1 ) {
                enqueueSnackbar( error[ key ], {
                    preventDuplicate : true,
                    variant          : 'error'
                });

                this.displayed.error = [
                    ...this.displayed.error,
                    key
                ];

                removeError( key );
            }
        }

        for( let key in warning ) {
            if( has.call( warning, key ) && this.displayed.warning.indexOf( key ) === -1 ) {
                enqueueSnackbar( warning[ key ], {
                    preventDuplicate : true,
                    variant          : 'warning'
                });

                this.displayed.warning = [
                    ...this.displayed.warning,
                    key
                ];

                removeWarning( key );
            }
        }

    }

    render() {
        return null;
    }
}

export default withSnackbar(Alert);